import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, Button, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import './styles.css';

const { Column } = Table;

const UsersAssistedRestaurantTable = ({ data, userSelected }) => {

    const renderFieldsTooltip = values => {
        var valueReturned = ""
        values.forEach((value, index) => {
            if(index !== 0) {
                if(index < (values.length - 1)) {
                    valueReturned = valueReturned + `${value}\n`
                } else {
                    valueReturned = valueReturned + `${value}`
                }
            }
        });
        return valueReturned
    }

    return (
        <Table className="usersAssistedRestaurantCont" dataSource={data} rowKey="dni" size="small" pagination={true}>
            <Column className="dniCont" title="DNI" dataIndex="dni" key="dni" align="center" />
            <Column className="firstNamesCont" title="Nombre/s" dataIndex="firstNames" key="firstNames" align="center"
            render={(text, record) => {
                if(record.firstNames.length > 1) {
                    return(
                        <Tooltip title={renderFieldsTooltip(record.firstNames)}>
                            <span>{record.firstNames[0]} <span className="usersAssistedRestaurantShowMore">[+]</span></span>
                        </Tooltip>
                    );
                } else {
                    return(
                        <span>{record.firstNames[0]}</span>
                    );
                }
            }}/>
            <Column className="lastNamesCont" title="Apellido/s" dataIndex="lastNames" key="lastNames" align="center"
            render={(text, record) => {
                if(record.lastNames.length > 1) {
                    return(
                        <Tooltip title={renderFieldsTooltip(record.lastNames)}>
                            <span>{record.lastNames[0]} <span className="usersAssistedRestaurantShowMore">[+]</span></span>
                        </Tooltip>
                    );
                } else {
                    return(
                        <span>{record.lastNames[0]}</span>
                    );
                }
            }}/>
            <Column className="emailsCont" title="Correo" dataIndex="emails" key="emails" align="center" 
            render={(text, record) => {
                if(record.emails.length > 1) {
                    return(
                        <Tooltip title={renderFieldsTooltip(record.emails)}>
                            <span>{record.emails[0]} <span className="usersAssistedRestaurantShowMore">[+]</span></span>
                        </Tooltip>
                    );
                } else {
                    return(
                        <span>{record.emails[0]}</span>
                    );
                }
            }}/>
            <Column className="reservationsCountCont" title="Reservas asistidas" dataIndex="reservationsCount" key="reservationsCount" align="center" />
            <Column title="" dataIndex="details" key="details" align="center"
                render={(text, record) => (
                    <Button type="primary" onClick={() => userSelected(record.dni)}>Ver reservas</Button>
                )}
            />
        </Table>
    );
};

UsersAssistedRestaurantTable.propTypes = {
    data: PropTypes.array,
};

export default UsersAssistedRestaurantTable;